import qs from "qs";
import moment_ from 'moment';

const moment = moment_;

/**
 * @author mam1bg
 * @date 2019-07
 * @licensor Robert Bosch GmbH, 2019
 * @version 1.0.0
 *
 * @jsdoc request
 * @name api.requests:GetTicketsRequest
 * @description
 * Ticket header request holding API query parameters.
 */

export class GetTicketsRequest {
  pageSize: number = null;
  offset: number = null;
  dateFrom: Date = null;
  dateTo: Date = null;
  ticketId: string = null;
  protocolNumber: string = null;
  boschOrderNumber: string = null;
  customerPONumber: string = null;
  boschInvoiceNumber: string = null;
  status: string = null;
  ticketType: string = null;
  qmNoteNumber: string = null;
  qmStatus: string = null;
  qmCustomerBook: string = null;
  qmAction: string = null;
  multiaccountSelected: string = null;

  /**
   * @jsdoc method
   * @name constructor
   * @methodOf api.requests:GetTicketsRequest
   * @description description
   * Sets request query default parameters.
   */
  constructor (
    pageSize?,
    offset?,
    dateFrom?,
    dateTo?,
    ticketType?,
    protocolNumber?,
    boschOrderNumber?,
    customerPONumber?,
    boschInvoiceNumber?,
    status?,
    qmNoteNumber?,
    qmCustomerBook?,
    qmStatus?,
    qmAction?,
    multiaccountSelected?
  ) {
    this.dateFrom = dateFrom ? new Date(dateFrom) : null;
    this.dateTo = dateTo ? new Date(dateTo) : null;
    this.protocolNumber = protocolNumber;
    this.boschOrderNumber = boschOrderNumber;
    this.customerPONumber = customerPONumber;
    this.boschInvoiceNumber = boschInvoiceNumber;
    this.status = status;
    this.ticketType = ticketType;
    this.pageSize = pageSize;
    this.offset = offset;
    this.qmNoteNumber = qmNoteNumber;
    this.qmStatus = qmStatus;
    this.qmCustomerBook = qmCustomerBook;
    this.qmAction = qmAction;
    this.multiaccountSelected = multiaccountSelected
  }


  /**
   * @jsdoc method
   * @name setQueryParam
   * @methodOf api.requests:GetTicketsRequest
   * @description description
   * Sets request query parameter. Allows only parameters that are class atributes
   */
  setQueryParam(name, value) {
    if (this.hasOwnProperty(name)) {
      this[name] = value === '' ? null : value;
    }
  }

  resetUniqueParams() {
    this.ticketId = null;
    this.boschOrderNumber = null;
    this.boschInvoiceNumber = null;
    this.customerPONumber = null;
    this.protocolNumber = null;
    this.dateFrom = null;
    this.dateTo = null;
    this.ticketType = null;
    this.offset = null;
    this.pageSize = null;
    this.qmNoteNumber = null;
    this.qmStatus = null;
    this.qmCustomerBook = null;
    this.qmAction = null;
    this.multiaccountSelected = null;
  }

  /**
   * @jsdoc method
   * @name toQueryString
   * @methodOf api.requests:GetOrdersRequest
   * @description description
   * Builds query string from class atributes.
   * Uses qs for query string and moment.js for date formatting according to interface requirements
   */
  toQueryString() {
    return qs.stringify(this, {
      addQueryPrefix: true,
      skipNulls: true,
      sort: null,
      serializeDate: (d) => {
        return moment(d).format('YYYY-MM-DD');
      }
    });
  }
}
